import { ReportsProvider } from '@reports/presentation/contexts';
import { SalesReportContent } from '@reports/presentation/components/specific/SalesReport';
import { PageLayout } from '@reports/presentation/components/base/PageLayout';

/**
 * Sales Report Page
 *
 * Entry point for the Sales Report.
 * Infrastructure dependencies are managed by composition root (initialized in App bootstrap).
 * Each report page is isolated with its own state through ReportsProvider.
 */
export const SalesReportPage = () => {
  return (
    <PageLayout>
      <ReportsProvider>
        <SalesReportContent />
      </ReportsProvider>
    </PageLayout>
  );
};
